import { EntityIds, ParsedEntity } from 'interfaces/entity-resolver'

export class RouteBuilder {
  /**
   * Build appropriate inventory route based on entity type and IDs
   */
  static buildRoute(parsed: ParsedEntity, entityIds: EntityIds): string {
    const { terminalId, ansibleId, macMiniId } = entityIds

    switch (parsed.entityType) {
      case 'terminal':
        return `/inventory/terminals/${terminalId}`

      case 'ansible':
        return `/inventory/terminals/${terminalId}/ansibles/${ansibleId}`

      case 'mac-mini':
        if (parsed.hasAnsible && ansibleId) {
          // Ansible-assigned Mac Mini
          return `/inventory/terminals/${terminalId}/ansibles/${ansibleId}/mac-mini/${macMiniId}`
        }
        // Received Mac Mini (no ansible)
        return `/inventory/terminals/${terminalId}/mac-minis/${macMiniId}`

      default:
        throw new Error(`Unknown entity type: ${parsed.entityType}`)
    }
  }
}
